export default "__VITE_ASSET__OzmdTOKX__"